import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DrawingWCFinalDataDto, WCGroupLooserDataDto, WCGroupWinnerDataDto, DrawingWCFinalDto, TeamShortDto, DrawingWCFinalResponseDto } from "app/models";
import { DrawingsService, NationalTeamService, NotificationService } from "app/services";

@Component({
    selector: 'wc-qualification',
    templateUrl: 'wc-qualification.page.html',
    styleUrls: ['wc-qualification.page.scss'],
})
export class WCQualificationPage implements OnInit {
    data: DrawingWCFinalDataDto;

    allNationalGroups: string[];
    allU21Groups: string[];

    nationalSquadsTotalCount: number = 0;
    u21SquadsTotalCount: number = 0;

    baskets: DrawingWCFinalDto;

    formGroup: FormGroup;

    drawingResult: DrawingWCFinalResponseDto;

    nationalRatings: number[] = [];
    
    constructor(private drawingService: DrawingsService, 
        private modalService: NgbModal,
        private notificationService: NotificationService,
        private nationalTeamService: NationalTeamService) { }
    
    ngOnInit(): void {
        this.loadRatings();
        this.getBaskets();
        this.buildFormGroup();
    }


    public getBaskets() {
        this.drawingService.getWCQualificationBaskets()
            .subscribe(result => {
                this.baskets = result;
            }, error => {

            })
    }


    doDraw() {
        if (!this.formGroup.controls.md1FormControl.value || !this.formGroup.controls.md2FormControl.value || !this.formGroup.controls.md3FormControl.value
            || !this.formGroup.controls.md4FormControl.value || !this.formGroup.controls.md5FormControl.value || !this.formGroup.controls.md6FormControl.value
            || !this.formGroup.controls.md6FormControl.value || !this.formGroup.controls.md7FormControl.value || !this.formGroup.controls.md8FormControl.value
            || !this.formGroup.controls.md9FormControl.value || !this.formGroup.controls.md10FormControl.value) {
            this.notificationService.showError('На заполенены ИД');
            
            return;
        }

        let mds: number[] = [this.formGroup.controls.md1FormControl.value, 
            this.formGroup.controls.md2FormControl.value,
            this.formGroup.controls.md3FormControl.value,
            this.formGroup.controls.md4FormControl.value,
            this.formGroup.controls.md5FormControl.value,
            this.formGroup.controls.md6FormControl.value,
            this.formGroup.controls.md7FormControl.value,
            this.formGroup.controls.md8FormControl.value,
            this.formGroup.controls.md9FormControl.value,
            this.formGroup.controls.md10FormControl.value,] 

        this.drawingService.drawWCQualification(mds)
            .subscribe(result => {
                this.drawingResult = result;
            }, error => {
                this.notificationService.showError('Ошибка жеребьевки');
            })
    }

    getNationalTeamRating(teamId: number): number {
        if (!this.nationalRatings)
            return 0;

        return this.nationalRatings[teamId];
    }


    private loadRatings() {
        this.nationalTeamService.getGroupRatings()
            .subscribe(result => {
                this.nationalRatings = [];
                result.forEach(item => {
                    this.nationalRatings[item.teamId] = item.rating;
                })
            }, error => {
                this.notificationService.showError('Не удалось загрузить рейтинги');
            })
    }


    private buildFormGroup() {
        this.formGroup = new FormGroup({
            md1FormControl: new FormControl(),
            md2FormControl: new FormControl(),
            md3FormControl: new FormControl(),
            md4FormControl: new FormControl(),
            md5FormControl: new FormControl(),
            md6FormControl: new FormControl(),
            md7FormControl: new FormControl(),
            md8FormControl: new FormControl(),
            md9FormControl: new FormControl(),
            md10FormControl: new FormControl(),
        })
    }
}